import { useInView } from 'react-intersection-observer'
import PlatformNumberGridCardLoading from './PlatformNumberGridCardLoading'
import { CountUp } from 'use-count-up'

export default function PlatformNumbersGridCard({ subTtile = null, title, count, isLoading, icon }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })
  if (isLoading || count === 0) {
    return <PlatformNumberGridCardLoading />
  }

  return (
    <div
      ref={ref}
      data-aos="fade-up"
      className="relative mb-5"
    >
      {subTtile && <span className="bg-muted-300 absolute left-0 top-0 px-2 py-1 text-xs">{subTtile}</span>}
      <div className="border-muted-300 flex h-full flex-col items-center justify-center gap-6 border-2 bg-light p-8">
        <img
          className="h-20 md:h-16"
          alt={title}
          src={icon}
        />
        <div className="flex flex-col items-center gap-2">
          <h4 className="text-secondary-600 text-3xl font-black">
            <CountUp
              isCounting={inView}
              start={0}
              end={count}
              duration={count > 100 ? 2 : 4}
            />
          </h4>
          <p className="whitespace-nowrap font-bold">{title}</p>
        </div>
      </div>
    </div>
  )
}
